export default "__VITE_ASSET__BdNYwTl5__"